import type { TPlan } from "@/core/environment/types";
import { environment } from "@environment";

const getSelectedPlan = (
  period = "annually",
  title = "pro",
  isEarlyBirds = false,
) => {
  const earlyBird = isEarlyBirds && period.toLowerCase() === "annually";
  return environment.paddle.plans.find(
    (p) =>
      p.title.toLowerCase() === title.toLowerCase() &&
      p.period.toLowerCase() === period.toLowerCase() &&
      (earlyBird ? p.earlyBird : p.active),
  ) as TPlan;
};

export default getSelectedPlan;
